import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=35d3fe4d&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports